import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../actions/ApiGo';
const PngReader =(props)=>{

    const {t} = useTranslation()
    // ------圖片路徑------
    const [urlHEROImage, setUrlHEROImage] = useState(null);
    const [urlImage, setUrlImage] = useState(null);
    // ------圖片路徑------

    // ------圖片大小------
    const [HeroSize, setHeroSize] = useState({height:0, width:0});
    const [LogoSize, setLogoSize] = useState({height:0, width:0});
    const [fromServer, setFromServer] = useState(false);
    // ------圖片大小------
    
    // 彈出裁減圖片警示
    const [popUpShow, setPopUpShow] = useState(false);
    function toggolePopUp(){ setPopUpShow(!popUpShow) }

    const [savingSuccess, setSavingSuccess] = useState(false);

    // ---------圖片DIV------------
    const LOGOImageDiv = <img src={`${urlImage}`} 
        className={`margb-xs ${urlImage===null? "empty-heroImg":""}`}  alt={"Logo"}
        width={LogoSize.width} height={LogoSize.height}
        onLoad={e=>{if(!fromServer){setLogoSize({height:e.target.naturalHeight, width:e.target.naturalWidth})}}}
        />
    const HEROImageDiv = <img src={`${urlHEROImage}`} 
        className={`margb-xs ${urlHEROImage===null? "empty-heroImg":""}`}  alt={"Hero"}
        width={HeroSize.width} height={HeroSize.height}
        onLoad={e=>{if(!fromServer){setHeroSize({height:e.target.naturalHeight, width:e.target.naturalWidth})}}}
        />
    // ---------圖片DIV-----------

    // fetch api
    useEffect(()=>{
        ApiGo.getInstitution_img()
        .then(res=>{
            setFromServer(true)
            try{
                if(res.HeroImg!==undefined){ 
                    setUrlHEROImage(res.HeroImg.exist)
                    setHeroSize({height:parseInt(res.HeroImg.height), width:parseInt(res.HeroImg.width)})
                }
            }
            catch{}
            try{
                if(res.LogoImg!==undefined){ 
                    setUrlImage(res.LogoImg.exist)
                    setLogoSize({height:parseInt(res.LogoImg.height), width:parseInt(res.LogoImg.width)}) 
                }
            }
            catch{}
        })
        .catch(err=>{console.log(err);})
    }, [])

    // fetch api

    // ---------抓 + 印 圖片-----------
    function printHEROFile(e){
        let file = e.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend=()=>{ setUrlHEROImage(reader.result) }
    }

    function printFile(e){
        let file = e.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend=()=>{ setUrlImage(reader.result) }   
    }
    // ---------抓 + 印 圖片-----------

    // --- 壓縮圖片判斷 + post ---
    function handlePostorSqueeze(){
        if(HeroSize.height<=800 && HeroSize.width<=1200 && LogoSize.width<=300 && LogoSize.height<=125){
            pooooostIMG(urlHEROImage, urlImage, HeroSize.height, HeroSize.width, LogoSize.height, LogoSize.width)
        }else{ toggolePopUp() }
    }

    function squeezeImage(){
        let [_logo_h, _logo_w, _hero_h, _hero_w] = [125, 300, 800, 1200]
        // 長寬比 處理
        let _HeroSizeRatio = HeroSize.width/HeroSize.height
        if(urlHEROImage!==null){
            if(_HeroSizeRatio<=2.4){ _hero_h = Math.floor(HeroSize.height*(1200/HeroSize.width)) }
            else{ _hero_w = Math.floor(HeroSize.width*(800/HeroSize.height)) }
        }
        let _LogoSizeRatio = LogoSize.width/LogoSize.height
        if(urlImage!==null){
            if(_LogoSizeRatio<=1.5){ _logo_h = Math.floor(LogoSize.height*(300/LogoSize.width))}
            else{ _logo_w = Math.floor(LogoSize.width*(125/LogoSize.height)) }
        }
        // 長寬比 處理
        pooooostIMG(urlHEROImage, urlImage, _hero_h, _hero_w, _logo_h, _logo_w)
        setHeroSize({height:_hero_h, width:_hero_w})
        setLogoSize({height:_logo_h, width:_logo_w})

        toggolePopUp()
    }
    
    function pooooostIMG(Hero, Logo, Hero_h, Hero_w, LOGO_h, LOGO_w){
        ApiGo.postInstitution_img("AIDC", Logo, Hero, LOGO_w, LOGO_h, Hero_w, Hero_h)
        .then(res=>{console.log(res);})
        .catch(err=>{console.log(err);})
        setSavingSuccess(true)
    }
    // --- 壓縮圖片判斷 + post ---

    // 彈出視窗
    const PopUpSign = <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black" onClick={toggolePopUp}>
            <div className="layout-squeeze fx-d-c " onClick={e=>e.stopPropagation()}>
                {/* <div className='margt-m'></div> */}
                <div className='w-100 h-50 bgLG pad-50 br-20-rl'>
                    您的圖片大小不符合格式，在登入畫面呈現時可能會造成畫面擠壓
                    <div className='font-ml'>
                        建議裁切後再次上傳或是使用自動壓縮功能
                    </div>
                </div>
                <div className='w-100 h-50 pad-50'>
                    <div className=''>是否要自動壓縮圖片?</div>
                    <div className='font-m margb-xs'>本功能會自動鎖定長寬比，不會造成圖片變形</div>
                    <div className='fx-d-r font-ml margb-xs'>
                        <div onClick={squeezeImage} className='w-20 bgC-alert-EE shadow-xs br-10 fx-ccc pad-5 l r b t margr-s cursor pt'>壓縮</div>
                        <div onClick={()=>{pooooostIMG(urlHEROImage, urlImage, HeroSize.height, HeroSize.width, LogoSize.height, LogoSize.width)}} className='w-20 bgC-alert-E shadow-xs br-10 fx-ccc pad-5 l r b t cursor pt'>不壓縮</div>
                    </div>
                </div>                
            </div>
        </div>
    // 彈出視窗


    return(
        <div className='font-l'>
            {popUpShow? PopUpSign:null}
            <div className="fx-d-c fx-fspar w-50 h-100">
                <div className='fx-d-r w-80'>
                    <div>{t('GLOBAL.LOGOIMG')}</div>
                    <input type="file" onChange={printFile} className="font-m margl-s"/>
                </div>
                <div className='fx-d-r font-ml margt-xxs w-100'>
                    <div className='w-30'>{t("ADMIN.OTHER_PAGE.WIDTH")} : 
                        <input type='text' 
                            className='bgC-white w-40 br-10 pad-15 l' 
                            onChange={e=>{setLogoSize({width:parseInt(e.target.value), height:LogoSize.height})}} value={LogoSize.width}/> px
                    </div>
                    <div className='w-30'>{t("ADMIN.OTHER_PAGE.HEIGHT")} : 
                        <input type='text' 
                            className='bgC-white w-40 br-10 pad-15 l' 
                            onChange={e=>{setLogoSize({height:parseInt(e.target.value), width:LogoSize.width})}} value={LogoSize.height}/> px
                    </div>
                </div>
                <div className='font-m'>{t("ADMIN.OTHER_PAGE.RECOMMEND_SIZE")} : 300px * 125px</div>
                {(urlImage===null)?
                    <div className='empty-logoImg margt-xs margb-xs' style={{width:"300px", height:"125px"}} data-content={t("GLOBAL.LOGOIMG")}>
                        <div className='bdr-dashed lt'></div>
                        <div className='bdr-dashed rt'></div>   
                        <div className='bdr-dashed lb'></div>
                        <div className='bdr-dashed rb'></div>
                    </div>:
                    <>
                        {/* <img src={`${urlImage}`} className="margb-xs" alt={"Logo image"}/> */}
                        {LOGOImageDiv}                       
                    </>}
            </div>
            <div className="fx-d-c fx-fspar w-50">

                {/* <input type="file" onChange={printFile} className="font-xxs"/> */}
                <div className='fx-d-r w-80'>
                    <div>{t('GLOBAL.HEROIMG_ADMIN')} : </div>
                    <input type="file" onChange={printHEROFile} className="font-m margl-s"/>
                </div>
                <div className='fx-d-r font-ml margt-xxs w-100'>
                <div className='w-30'>{t("ADMIN.OTHER_PAGE.WIDTH")} : 
                        <input type='text' 
                            className='bgC-white w-40 br-10 pad-15 l' 
                            onChange={e=>{setHeroSize({width:parseInt(e.target.value), height:HeroSize.height})}} value={HeroSize.width}/> px
                    </div>
                    <div className='w-30'>{t("ADMIN.OTHER_PAGE.HEIGHT")} : 
                        <input type='text' 
                            className='bgC-white w-40 br-10 pad-15 l' 
                            onChange={e=>{setHeroSize({height:parseInt(e.target.value), width:HeroSize.width})}} value={HeroSize.height}/> px
                    </div>
                </div>
                <div className='font-m'>{t("ADMIN.OTHER_PAGE.RECOMMEND_SIZE")} : 1200px * 800px</div>
                {(urlHEROImage===null)?
                    <div className='empty-heroImg margt-xs margb-xs font-l' 
                        style={{width:"1200px", height:"800px"}} 
                        data-content={t('GLOBAL.HEROIMG_ADMIN')}>
                        <div className='bdr-dashed lt'></div>
                        <div className='bdr-dashed rt'></div>
                        <div className='bdr-dashed lb'></div>
                        <div className='bdr-dashed rb'></div>
                    </div>:
                    <>
                        {HEROImageDiv}
                    </>
                }
            </div>
            <div className='fx-d-r fx-fsc '>
                <div className='margb-s'>
                    <div className="font-l bgC wid-admin-s hig-xs br-10 shadow-xs fx-cc cursor pt" 
                        onClick={handlePostorSqueeze}>{t("PAD.UPLOAD")}</div>
                    {savingSuccess? <div className='margl-xs green'>{t("GLOBAL.CONFIRM")}</div>:null}
                </div>
            </div>
        </div>
    );	

}
export default PngReader;